import { Component, Input } from '@angular/core';
import { ResponseGetBotInterface } from '../../../../models/bot.interface';
import { Clipboard } from '@angular/cdk/clipboard';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'globot-embed-wordpress',
  template: `
    <div class="grid">
      <p-messages severity="info">
        <ng-template pTemplate>
          <i class="pi pi-info-circle" style="font-size: 1rem"></i>
          <div class="ml-2:md text-message">
            <p>
              Asegúrate de tener acceso como administrador. Si no eres tú quién administra el sitio,
              contáctate con la persona que tenga acceso.
            </p>
          </div>
        </ng-template>
      </p-messages>
      <div class="mt-5">
        <p>1. En Wordpress anda a <b>Plugins / Añadir nuevo / Subir plugin</b></p>
        <p>
          2. Carga el siguiente archivo:
          <button (click)="download()" class="btn-download ml-4">
            Globot.zip <i class="pi pi-download"></i>
          </button>
        </p>
        <p>3. Dale click a <b>“Instalar ahora”</b> y <b>activa el plugin</b>.</p>
        <p>4. Anda al plugin de <b>Globot</b> e ingresa los siguientes datos:</p>
        <div style="display: flex; flex-direction: row;margin-left:20px">
          <div class="flex flex-column">
            <p>Token:</p>
            <p>Bot ID:</p>
          </div>
          <div class="flex flex-column ml-4 gap-4">
            <span class="p-input-icon-right">
              <input pInputText [disabled]="true" [(ngModel)]="bot!.token" />
              <i
                class="pi pi-copy"
                style="color: #B869DE;"
                (click)="copyCodeToClipboard(bot!.token)"
              ></i>
            </span>
            <span class="p-input-icon-right">
              <input pInputText [disabled]="true" [(ngModel)]="bot!.id" />
              <i
                class="pi pi-copy"
                style="color: #B869DE;"
                (click)="copyCodeToClipboard(bot!.id)"
              ></i>
            </span>
          </div>
        </div>
        <p>
          5. <b>¡Listo!</b> Tu asistente se encontrará disponible para interactuar en la esquina
          inferior derecha de tu sitio.
        </p>
      </div>
      <a
        [href]="getDownloadLink()"
        download="{{ zipFileName }}"
        style="display: none;"
        id="downloadLink"
      ></a>
    </div>
  `,
  styleUrls: ['./embed-wordpress.component.scss'],
})
export class EmbedWordpressComponent {
  @Input() bot!: ResponseGetBotInterface | undefined;
  zipFileName = 'globot.zip';
  constructor(private clipboard: Clipboard, private sanitizer: DomSanitizer) {
    if (window.location.origin.includes('app-dev')) {
      this.zipFileName = 'globot-dev.zip';
    }
  }
  copyCodeToClipboard(input: string) {
    this.clipboard.copy(input);
  }

  getDownloadLink() {
    const path = `assets/plugins/${this.zipFileName}`;
    // @SonarIgnore
    return this.sanitizer.bypassSecurityTrustResourceUrl(path);
  }

  download(): void {
    const link = document.getElementById('downloadLink') as HTMLAnchorElement;
    link.click();
  }
}
